module.exports = __webpack_public_path__ + "img/homeBanner1.77a07d3f.png";